import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import FloatingContactButtons from '../../components/FloatingContactButtons';
import CallMeBackPopup from '../../components/CallMeBackPopup';

const TempoTravellerAmritsar = () => {
  const navigate = useNavigate();
  const [showCallMeBack, setShowCallMeBack] = React.useState(false);

  const routes = [
    { id: 1, destination: 'Agra', fareStart: 47600, route: 'amritsar-agra' },
    { id: 2, destination: 'Amarnath', fareStart: 42000, route: 'amritsar-amarnath' },
    { id: 3, destination: 'Ayodhya', fareStart: 84000, route: 'amritsar-ayodhya' },
    { id: 4, destination: 'Badrinath Kedarnath', fareStart: 86800, route: 'amritsar-badrinath-kedarnath' },
    { id: 5, destination: 'Char Dham', fareStart: 86800, route: 'amritsar-char-dham' },
    { id: 6, destination: 'Dalhousie', fareStart: 25200, route: 'amritsar-dalhousie' },
    { id: 7, destination: 'Dharamshala', fareStart: 30800, route: 'amritsar-dharamshala' },
    { id: 8, destination: 'Govind Ghat', fareStart: 84000, route: 'amritsar-govind-ghat' },
    { id: 9, destination: 'Jaipur', fareStart: 47600, route: 'amritsar-jaipur' },
    { id: 10, destination: 'Jim Corbett', fareStart: 47600, route: 'amritsar-jim-corbett' },
    { id: 11, destination: 'Kasauli', fareStart: 47600, route: 'amritsar-kasauli' },
    { id: 12, destination: 'Kashmir', fareStart: 42000, route: 'amritsar-kashmir' }
  ];

  const handleViewCabs = (route) => {
    navigate(`/tempo-traveller-booking/${route}`);
  };

  return (
    <>
      <Helmet>
        <title>Tempo Traveller From Amritsar | Advait Tour and Travels</title>
        <meta name="description" content="Book tempo traveller from Amritsar to various destinations. Comfortable group travel with competitive pricing." />
      </Helmet>
      <div className="min-h-screen flex flex-col bg-gray-50">
        <Header />
        
        <main className="flex-grow">
          {/* Hero Section */}
          <div className="bg-gradient-to-r from-blue-600 to-blue-400 text-white py-16">
            <div className="container mx-auto px-4">
              <h1 className="text-4xl md:text-5xl font-bold text-center">
                Tempo Traveller From Amritsar
              </h1>
            </div>
          </div>

          {/* Routes Grid */}
          <div className="container mx-auto px-4 py-12">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {routes?.map((route) => (
                <div
                  key={route?.id}
                  className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
                >
                  <h3 className="text-xl font-bold text-gray-800 mb-2">
                    Amritsar To {route?.destination}
                  </h3>
                  <p className="text-gray-600 mb-1">Fare Start -</p>
                  <p className="text-2xl font-bold text-gray-800 mb-4">
                    ₹ {route?.fareStart?.toLocaleString('en-IN')} /-
                  </p>
                  <button
                    onClick={() => handleViewCabs(route?.route)}
                    className="w-full bg-yellow-400 hover:bg-yellow-500 text-black font-bold py-3 px-6 rounded transition-colors"
                  >
                    VIEW CABS
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Visitor's Guide Section */}
          <div className="bg-white py-12">
            <div className="container mx-auto px-4">
              <h2 className="text-3xl md:text-4xl font-bold text-center text-orange-500 mb-8">
                Visitor's Guide
              </h2>
              <div className="max-w-4xl mx-auto text-gray-700 space-y-4">
                <p>
                  Explore incredible destinations from Amritsar with our comfortable tempo traveller services. 
                  Whether you're planning a spiritual journey, hill station getaway, or family vacation, 
                  we offer reliable and affordable group travel solutions.
                </p>
                <p>
                  Our tempo travellers are well-maintained, spacious, and perfect for group travel. 
                  All fares include driver charges, toll taxes, and state permits. Book now for a hassle-free journey!
                </p>
              </div>
            </div>
          </div>
        </main>

        <Footer />
        <FloatingContactButtons onCallMeBackClick={() => setShowCallMeBack(true)} />
        {showCallMeBack && (
          <CallMeBackPopup isOpen={showCallMeBack} onClose={() => setShowCallMeBack(false)} />
        )}
      </div>
    </>
  );
};

export default TempoTravellerAmritsar;